import { render } from "./vderpartnerlist.vue?vue&type=template&id=f7483d22&scoped=true"
import script from "./vderpartnerlist.vue?vue&type=script&lang=js"
export * from "./vderpartnerlist.vue?vue&type=script&lang=js"

import "./vderpartnerlist.vue?vue&type=style&index=0&id=f7483d22&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7483d22"]])

export default __exports__